import React, { useEffect, useState } from "react";
import { request } from "src/hooks/api";
import wallet from "../../../assets/images/wallet.png";
import FoodLoader from "src/components/Loader";

interface BankDetailsProps {
  restaurantId: string;
}

interface BankDetailsData {
  bank: string;
  account_number: string;
  account_name: string;
}

const BankDetailsTab: React.FC<BankDetailsProps> = ({ restaurantId }) => {
  const [bankDetails, setBankDetails] = useState<BankDetailsData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchRestaurantBankDetails = async () => {
      setLoading(true);
      try {
        const response = await request(
          `/admins/restaurants/account-details/${restaurantId}`,
          "GET",
          {},
          true,
          false,
          false
        );

        if (response && response.data) {
          setBankDetails(response.data); // Update bank details state
        } else {
          throw new Error("Unexpected response format");
        }
      } catch (error) {
        console.error("Error fetching bank details:", error);
        setError("Error fetching bank information");
      } finally {
        setLoading(false);
      }
    };

    if (restaurantId) {
      fetchRestaurantBankDetails();
    } else {
      console.warn("restaurantId is undefined");
      setError("Invalid restaurantId");
      setLoading(false);
    }
  }, [restaurantId]);

  if (loading) {
    return (
      <div className="h-[70vh] w-full bg-white flex flex-col items-center justify-center">
        <FoodLoader
          size="md"
          text="Fetching Bank Details"
          theme="amber"
          className="scale-75"
        />
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!bankDetails) {
    return <div>No bank details available</div>;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-10">
      <div className="bg-white shadow-md rounded-xl w-full max-w-md p-6 sm:p-8">
        {/* Header */}
        <div className="flex flex-col sm:flex-row items-center gap-4 mb-6 text-center sm:text-left">
          <img
            src={wallet}
            alt="Bank Icon"
            className="w-16 h-16 object-contain"
          />
          <h3 className="text-2xl sm:text-3xl font-bold text-gray-800">
            Bank Information
          </h3>
        </div>

        {/* Bank Details */}
        <div className="space-y-3 text-[16px] text-gray-700">
          <div>
            <span className="font-medium text-gray-600">Bank:</span>{" "}
            {bankDetails.bank}
          </div>
          <div>
            <span className="font-medium text-gray-600">Account Number:</span>{" "}
            {bankDetails.account_number}
          </div>
          <div>
            <span className="font-medium text-gray-600">Account Name:</span>{" "}
            {bankDetails.account_name}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankDetailsTab;
